import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Button, CircularProgress } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Axios from "utils/Axios";
import Avatar from "@mui/material/Avatar";
import { useParams } from "react-router-dom";
import coverImageDefault from "../../../assets/images/groove-sign-up.jpg";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function EventSettings() {
  const [showAddImage, setShowAddImage] = useState(false);
  const [files, setFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [dragging, setDragging] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [actionLoading, setActionLoading] = useState(null); // Track which image is being processed
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const [rows, setRows] = useState(null);

  useEffect(() => {
    getEventMedia();
  }, [id]);

  const onChange = (e) => {
    const newFiles = e.target.files || e.dataTransfer.files;
    handleFiles(newFiles);
  };

  const handleFiles = (newFiles) => {
    const validFiles = Array.from(newFiles).filter((file) => file.type.startsWith("image/"));
    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    setDragging(false);
  };

  const removeFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const removeAllFiles = () => {
    setFiles([]);
  };

  const discard = () => {
    setShowAddImage(false);
    removeAllFiles();
  };

  const saveEventMedia = () => {
    setLoading(true); // Start loading
    const formData = new FormData();
    formData.append("type", "eventMedia");
    formData.append("event_id", id);
    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });
    Axios.post("", formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        discard()
        getEventMedia();
      })
      .catch((error) => {
        console.error("Error uploading files:", error);
      })
      .finally(() => {
        setLoading(false);
        setLoading(false);
      });
  };

  const getEventMedia = () => {
    Axios.get(`?type=eventMedia&event_id=${id}`)
      .then((response) => {
        setImages(response.data || []);
      })
      .catch((error) => {
        console.error("Error fetching event media:", error);
      });
  };

  const toggleImageStatus = (imageId, currentStatus) => {
    setActionLoading(imageId);
    const newStatus = currentStatus === 1 ? 0 : 1;
    
    Axios.put(`?type=eventMedia&image_id=${imageId}&status=${newStatus}`)
      .then((response) => {
        // Update the image status in the local state
        setImages(prevImages => 
          prevImages.map(img => 
            img.id === imageId ? { ...img, status: newStatus } : img
          )
        );
      })
      .catch((error) => {
        console.error("Error updating image status:", error);
      })
      .finally(() => {
        setActionLoading(null);
      });
  };

  const deleteImage = (imageId) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      setActionLoading(imageId);
      
      Axios.delete(`?type=eventMedia&image_id=${imageId}`)
        .then((response) => {
          // Remove the deleted image from the local state
          setImages(prevImages => prevImages.filter(img => img.id !== imageId));
        })
        .catch((error) => {
          console.error("Error deleting image:", error);
        })
        .finally(() => {
          setActionLoading(null);
        });
    }
  };

  const imageUrl = (image) => {
    const parts = image.split('_');
    if (parts.length >= 3) {
      parts.splice(3, 0, 'img_250');
      image = parts.join('_');
    }
    return `${process.env.REACT_APP_BASE_IMAGE_URL}gallery/${image}`;
  };

  // Get Event Info
  const getSigleEvent = () => {
    Axios.get(`?type=event&id=${id}`)
      .then((response) => {
        //console.log(response.data);
        setRows(response.data);
      })
      .catch((error) => {
        console.error("Failed to fetch events data", error);
      });
  };
  useEffect(() => {
    getSigleEvent();
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <div className="flex justify-between py-2.5">
        <div>
        <span className="itemValue text-2xl font-semibold">
                  {rows?.title} / {rows?.date}
                </span>
          <div className="lg:mx-12 my-2">
            <div className="text-2xl py-0 text-primary">Event Photo Gallery:</div>

            <div className="text-sm font-light py-2">
              Add your Photos from the Event.  These will be displayed on the Previous Event Page.
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <button
            onClick={() => {
              setShowAddImage(!showAddImage);
            }}
            type="button"
            className="focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2"
          >
            Add New Images
          </button>
        </div>
      </div>
      {showAddImage ? (
        <div className="py-5 gallery-new-images">
          <div style={{ marginTop: "20px" }}>
            <div
              className={`dropZone ${dragging ? "dropZone-over" : ""}`}
              onDragEnter={() => setDragging(true)}
              onDragLeave={() => setDragging(false)}
              onDrop={(e) => {
                e.preventDefault();
                onChange(e);
              }}
              onDragOver={(e) => e.preventDefault()}
            >
              <div className="dropZone-info">
                <InsertDriveFileIcon style={{ fontSize: "48px" }} />
                <br />
                <CloudUploadIcon className="dropZone-title" style={{ fontSize: "48px" }} />
                <span className="dropZone-title">
                  <strong>Drop images here or click to upload</strong>
                </span>
                <div className="dropZone-upload-limit-info">
                  <div>If you are having issues Uploading Files, try to Add Fewer at a time.</div>
                </div>
              </div>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={onChange}
                style={{ display: "none" }}
                id="file-input"
              />
              <label
                htmlFor="file-input"
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                }}
              />
            </div>

            {files.length > 0 && (
              <div style={{ marginTop: "20px" }}>
                <button
                  onClick={removeAllFiles}
                  type="button"
                  className="focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2"
                >
                  Remove All Images
                </button>
                <div style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}>
                  {files.map((file, index) => (
                    <div key={index} style={{ margin: "10px", position: "relative" }}>
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => removeFile(index)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-end py-2.5">
            <button
              type="button"
              onClick={discard}
              className="text-purple-700 hover:text-white border border-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            >
              Discard
            </button>
            <button
              onClick={saveEventMedia}
              type="button"
              className="focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 mb-2"
              disabled={loading} // Disable the button when loading
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Save All"}
            </button>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {/* Define four inner divs that always exist */}
        {[0, 1, 2, 3].map((col) => (
          <div key={col} className="grid gap-4">
            {images
              .filter((_, index) => index % 4 === col) // Dynamically assign images to this column
              .map((image, index) => (
                <div key={image.id || index} className="relative group">
                  <img
                    className={`h-auto max-w-full rounded-lg ${image.status === 0 ? 'opacity-50' : ''}`}
                    src={imageUrl(image.title)} // Generate the dynamic URL
                    alt={image.title} // Image alt text
                  />
                  <div className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity right-2 flex space-x-2">
                    {actionLoading === image.id ? (
                      <CircularProgress size={24} color="inherit" className="text-white" />
                    ) : (
                      <>
                        <button 
                          onClick={() => toggleImageStatus(image.id, image.status)}
                          className="px-1.5 bg-white rounded-full hover:bg-gray-200 text-gray-700"
                          title={image.status === 1 ? "Disable image" : "Enable image"}
                        >
                          {image.status === 1 ? 
                            <VisibilityIcon fontSize="small" /> : 
                            <VisibilityOffIcon fontSize="small" />
                          }
                        </button>
                        <button 
                          onClick={() => deleteImage(image.id)}
                          className="px-1.5 bg-white rounded-full hover:bg-gray-200 text-red-600"
                          title="Delete image"
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
    </Box>
  );
}
